import React, { Component, Fragment } from 'react';
import { Route,  Link } from 'react-router-dom'
import { connect } from 'react-redux';

import Survey from '../../containers/Survey/Survey';
import './Portal.css';
import * as actionType from '../../../utilities/ActionType';

import { getAssessment } from '../../../actions/AssessmentsAction';

class Portal extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			assessments: [], 
			assessButtonEnabledStatus: false 
		}
	}

    componentDidMount () {
    	const params = new URLSearchParams(this.props.location.search);
		const { getAssessment, onResetSurvey } = this.props;
		
		if (params.has("guid")) {
			let guid = params.get("guid");
			getAssessment(guid);
			onResetSurvey();
		}
	}
	
	static getDerivedStateFromProps = (props, state) => {
		const newSelectedAssessmentsList = props.selectedAssessmentsList;

		if (newSelectedAssessmentsList !== state.assessments) {
			newSelectedAssessmentsList.forEach(assessment => {
				assessment.key = assessment.assessmentId;
			});

			return {
				assessments:newSelectedAssessmentsList
			}
		}
		return true;
	}

	toggleAssessmentHandler = (dataCollectionGuid) => {
		try {
			let newAssessments = this.state.assessments;
			let selectedCount = 0;
			let newAssessButtonEnabledStatus = false;

			newAssessments.forEach(assessment => {
				if (assessment.dataCollectionGuid === dataCollectionGuid) {

					if (assessment.isSelected === undefined || assessment.isSelected === false) {
						assessment.isSelected = true;
					}

					if (assessment.isSelected === true) {
						selectedCount++;
					}
				}
			});

			if (selectedCount > 0) {
				newAssessButtonEnabledStatus = true;
			}

			this.setState({ assessments: newAssessments, assessButtonEnabledStatus: newAssessButtonEnabledStatus });
		} catch (error) {
			console.log("Exception: while selecting assessment:_", error);
		}
	}

	assessButtonHandler = () => {
		try {
			const { onClearFormGuid, onRemoveAllAssessments, onAddAssessment, onSetFormGuid, onResetSurvey, onResetSurveyProgress } = this.props;
			const { assessments } = this.state;

			onRemoveAllAssessments();
			onClearFormGuid();
			onResetSurvey();
			onResetSurveyProgress();
			
			let formGuid = null;

			assessments.forEach(assessment => {
				if (assessment.isSelected) {
					onAddAssessment(assessment);

					if (formGuid === null) {
						formGuid = assessment.formXmlGuid;
						onSetFormGuid(formGuid);
					}
				}
			});
		} catch (error) {
			console.log("Exception: while click on assessment:_", error);
		}
	}

    render () {
		const { assessments, assessButtonEnabledStatus } = this.state;
		
        return (
			<Fragment>
			
            <div className='Portal' key="Portal">
                { assessments.map(assessment => {
                    return (
						<label key={assessment.dataCollectionGuid} className='container'>{assessment.participantName}
							<input 
								type='checkbox' 
								checked={assessment.isSelected || false} 
								onChange={() => { this.toggleAssessmentHandler(assessment.dataCollectionGuid)}} 
							/>
							<span className='checkmark'></span>
						</label>
					)

                })}
				<Link 
					className='button' 
					disabled={!assessButtonEnabledStatus} 
					to="/survey" 
					onClick={() => {this.assessButtonHandler()}}
				>Assess Now</Link>
                <Route path="/survey" exact component={Survey} />
            </div>
			</Fragment>
        )
    }
}


const mapStateToProps = state => ({
	selectedAssessmentsList:state.selectedAssessments.selectedAssessmentsList,
	selectedAssessments: state.selectedAssessments.selectedAssessments,
	formGuid: state.selectedAssessments.formGuid
});


const mapDispatchToProps = dispatch => ({
	onRemoveAllAssessments: () => dispatch({type: actionType.REMOVE_ALL_ASSESSMENTS}),
	onAddAssessment: (assessment) => dispatch({type: actionType.ADD_ASSESSMENT, assessmentObject: assessment}),
	onSetFormGuid: (guid) => dispatch({type: actionType.SET_FORM_GUID, formGuid: guid}),
	onClearFormGuid: (guid) => dispatch({type: actionType.CLEAR_FORM_GUID}),
	getAssessment: (guid) => dispatch(getAssessment(guid)),
	onResetSurvey: () => dispatch({type: actionType.RESET_ALL_SURVEY}),
	onResetSurveyProgress: () => dispatch({type: actionType.GET_ANSWERED_QUESTION, answeredQuestionCount:0}),
})


export default connect(mapStateToProps, mapDispatchToProps)(Portal);